// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-components-Common-LoadingSpinner-style__loading--slut7{width:24px;height:24px;animation:src-components-Common-LoadingSpinner-style__spin--tp3y1 1s linear infinite}.src-components-Common-LoadingSpinner-style__loading--slut7.src-components-Common-LoadingSpinner-style__sizeS--Alvi9{width:12px;height:12px}.src-components-Common-LoadingSpinner-style__loading--slut7.src-components-Common-LoadingSpinner-style__sizeL--k6NOo{width:36px;height:36px}@keyframes src-components-Common-LoadingSpinner-style__spin--tp3y1{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}", "",{"version":3,"sources":["webpack://./src/components/Common/LoadingSpinner/style.scss"],"names":[],"mappings":"AACA,4DACE,UAAA,CACA,WAAA,CACA,oFAAA,CAEA,qHACE,UAAA,CACA,WAAA,CAGF,qHACE,UAAA,CACA,WAAA,CAIJ,mEACE,GACE,sBAAA,CAGF,KACE,wBAAA,CAAA","sourcesContent":["@use 'src/utils/css/variables' as *;\n.loading {\n  width: 24px; // default size (M)\n  height: 24px; // default size (M)\n  animation: spin 1s linear infinite;\n\n  &.sizeS {\n    width: 12px;\n    height: 12px;\n  }\n\n  &.sizeL {\n    width: 36px;\n    height: 36px;\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lHeaderHeight": "56px",
	"lCompanyHeight": "114px",
	"h2FontSize": "28px",
	"h3FontSize": "20px",
	"bodyLineHeight": "20px",
	"lGnShrinkWindowWidth": "1591px",
	"tableVerticalPadding": "8px",
	"tableHorizontalPadding": "16px",
	"lPersonnelBreakWidth": "1599px",
	"cNavigationAccent": "#f57f17",
	"cTableBodyOdd": "#fff",
	"cTableBodyEven": "#f2f6f8",
	"cTableHover": "#c5ddeb",
	"cTableHeadOdd": "#eaf1f5",
	"cTableHeadEven": "#dee8ef",
	"zPageLoading": "2",
	"loading": "src-components-Common-LoadingSpinner-style__loading--slut7",
	"spin": "src-components-Common-LoadingSpinner-style__spin--tp3y1",
	"sizeS": "src-components-Common-LoadingSpinner-style__sizeS--Alvi9",
	"sizeL": "src-components-Common-LoadingSpinner-style__sizeL--k6NOo"
};
export default ___CSS_LOADER_EXPORT___;
